
import PerfectScrollbar from 'perfect-scrollbar';

import { MESSAGES_PAGE_SIZE } from './user-interactions-material.controller';

interactionWithOneSite.$inject = ['ScrollFactory', 'ExternalUserFactory', 'AlertingFactory', '$timeout', '$filter', '$q', '$translate', 'ConfirmationFactory', 'AngularOptinsService'];
export function interactionWithOneSite(ScrollFactory, ExternalUserFactory, AlertingFactory, $timeout, $filter, $q, $translate, ConfirmationFactory, AngularOptinsService) {
  return {
    restrict: 'E',
    template: require('./interaction-with-one-site.directive.html'),
    scope: {
      interaction: '<',
      crmTabs: '<',
      goToTab: '&',
      goToCrmTab: '&',
      companyId: '<',
      siteId: '<',
      userId: '<',
      userOptins: '<',
      openedFromTaskId: '<',
    },
    link: link
  };

  function link($scope, element) {

    $scope.waitThenEnableInfinteScroll = waitThenEnableInfinteScroll;
    $scope.loadMoreMessages = loadMoreMessages;
    $scope.applyUserAction = applyUserAction;
    $scope.scrollToMessage = scrollToMessage;
    $scope.deleteUserOptin = deleteUserOptin;

    init();

    function deleteUserOptin(userOptin) {
      ConfirmationFactory.materialConfirmDialog('optins/confirm_user_optin_deletion')
        .then(function () {
          AngularOptinsService.deleteUserOptin(userOptin, $scope.userId)
            .subscribe({
              next: () => {
                const index = $scope.userOptins.indexOf(userOptin);
                $scope.userOptins.splice(index, 1);
              }
            });

        });
    }

    function waitThenEnableInfinteScroll() {
      $timeout(() => {
        $scope.infiniteScrollEnabled = true;
      }, 1000);
    }

    function loadMoreMessages() {
      loadMoreMessagesThenMaybeScroll(MESSAGES_PAGE_SIZE, true);
    }

    /**
     * Lazyloads the given number of messages;
     * then, if the given boolean is true, scrolls the messages column
     * so that the same messages are displayed before and after inserting 
     * the newer messages in the DOM
     */
    function loadMoreMessagesThenMaybeScroll(numberOfMessages, restoreScrollView) {
      let result = $q.reject();
      if (!$scope.loadingMoreMessages) {
        $scope.loadingMoreMessages = true;
        const messageIdsToLoad = $scope.loadableMessageIds.splice(0, numberOfMessages);
        if ($scope.loadableMessageIds.length === 0) {
          // no more messages to load, let's disable infinite scroll
          $scope.infiniteScrollEnabled = false;
        }
        result = ExternalUserFactory.lazyloadMessages($scope.companyId, $scope.siteId, $scope.userId, messageIdsToLoad)
          .then(response => afterMoreMessagesLoaded(response.data, restoreScrollView),
            response => {
              $scope.loadingMoreMessages = false;
              AlertingFactory.httpErrorHandler()(response); // double parenthesis normal here (handler() returns a function)
            });
      }
      return result;
    }

    function afterMoreMessagesLoaded(messages, restoreScrollView) {
      $scope.loadedMessages.push(...messages);
      updateMessagesDayIndicators();
      updateSkipAvatarAndReduceMargin();

      const firstMessageBeforePush = element.find('.messages-container > div:first-child .avatar-and-bubble-container');
      const positionBeforePush = positionInMessagesContainer(firstMessageBeforePush);
      $timeout(() => {
        $scope.loadingMoreMessages = false;
        if (restoreScrollView) {
          // try to adjust scroll so that the same messages are displayed before and after prepending the newly loaded messages
          const positionDelta = positionInMessagesContainer(firstMessageBeforePush) - positionBeforePush;
          ScrollFactory.scrollContainerDelta(element.find('.interactions-column'), positionDelta);
        }
      }, 0); // let the browser take the new elements into account when computing message positions

    }

    /**
     * Computes which messaged should display a date above them 
     * (so that all messages of the same day are grouped under that day),
     * and sets the correpsonding formatted date to these messages.
     * 
     * A message shoudld display a date indicator 
     * either if it is the oldest, 
     * or if the next message was sent on a different day
     * 
     * Note: the messages are displayed in reversed order in the UI, as per the orderBy:'-' filter
     */
    function updateMessagesDayIndicators() {
      const messages = $scope.loadedMessages;
      const msInADay = 1000 * 60 * 60 * 24;
      const startIndex = Math.max(0, messages.length - MESSAGES_PAGE_SIZE - 1); // include last message from the previous load
      for (let i = startIndex; i < messages.length; i++) {
        const message = messages[i];
        const messageDate = new Date(message.created_time);
        const nextMessageDate = (i + 1 < messages.length) ? new Date(messages[i + 1].created_time) : new Date(0); // use 1970-01-01 for last message
        const messageDay = Math.floor(messageDate.getTime() / msInADay);
        const nextMessageDay = Math.floor(nextMessageDate.getTime() / msInADay);
        if (messageDay !== nextMessageDay) {
          let format = 'd MMMM';
          if (messageDate.getFullYear() !== new Date().getFullYear()) {
            format += ' yyyy';
          }
          message.dayIndicator = $filter('dateTimezone')(messageDate, format);
        } else {
          message.dayIndicator = null; // ovewrite with null for the "previously last" message after loading more messages of the same day
        }
      }
    }

    function updateSkipAvatarAndReduceMargin() {
      const messages = $scope.loadedMessages;
      const startIndex = Math.max(1, messages.length - MESSAGES_PAGE_SIZE); // include last message from the previous load
      for (let i = startIndex; i < messages.length; i++) {
        const message = messages[i];
        const previousMessage = messages[i - 1];
        const sameSender = message.is_from_self === previousMessage.is_from_self;
        if (sameSender && !previousMessage.dayIndicator) {
          previousMessage.skipAvatar = true;
          message.smallerBottomMargin = true;
        }
      }
    }

    function positionInMessagesContainer(message) {
      return message.position().top; // the offset parent is md-card.interactions-column 
      // (or at least it should be, for the "scroll back to message" mechanism to work)
    }

    function applyUserAction(actionType) {
      const data = {
        'action_type': actionType,
        'task_id': $scope.openedFromTaskId,
        'site_id': $scope.siteId
      };
      ExternalUserFactory.userAction($scope.companyId, $scope.userId, data, true)
        .then((response) => {
          updateNonVipActions(response.data.user.actions_allowed);
          AlertingFactory.success('message/action/ok');
        },
          response => {
            const message = response.data.error_translation ? response.data.error_translation
              : ($translate.instant('error') + ' ' + response.satus);
            AlertingFactory.error(message);
          });
    }

    function updateNonVipActions(allowedActions) {
      $scope.nonVipActions = allowedActions ? allowedActions.filter(a => a.action_type !== 'tag_vip' && a.action_type !== 'untag_vip')
        : [];
    }

    function scrollToLoadedMessage(id) {
      const container = element.find('.interactions-column');
      const firstMessage = element.find('.messages-container > div:first-child avatar-and-bubble');
      const targetBubble = element.find('#avatar-and-bubble-' + id);
      const scrollDuration = 200;
      const delayBeforeBlink = 50;

      ScrollFactory.scrollContainerToElement(container, firstMessage, targetBubble, 10, scrollDuration);
      blinkBubble(targetBubble, scrollDuration + delayBeforeBlink);
    }

    function blinkBubble(bubble, delayBefore) {
      const blinkClass = 'alc-blink';
      const blinkDuration = 1000;
      $timeout(() => {
        bubble.addClass(blinkClass);
        $timeout(() => {
          bubble.removeClass(blinkClass);
        }, blinkDuration);
      }, delayBefore);
    }

    /**
     * Scrolls to the given message id,
     * after lazyloading enough messages if the given id is not loaded yet
     */
    function scrollToMessage(id) {
      if ($scope.loadedMessages.find(message => message.id === id)) {
        scrollToLoadedMessage(id);
      } else if ($scope.loadableMessageIds.includes(id)) {
        // load enough messages so that the requested id becomes the last loaded message
        const numberOfMessages = 1 + $scope.loadableMessageIds.indexOf(id);
        loadMoreMessagesThenMaybeScroll(numberOfMessages, false)
          .then(() => {
            // wait for new messages to be in the DOM tree before attempting to scroll
            $timeout(() => scrollToLoadedMessage(id), 0);
          });
      }
    }

    function init() {
      $scope.loadedMessages = $scope.interaction.messages;
      $scope.loadableMessageIds = $scope.interaction.message_ids;
      $scope.numberOfInteractions = $scope.interaction.message_ids.length;
      $scope.loadableMessageIds.splice(0, $scope.loadedMessages.length);

      updateMessagesDayIndicators();
      updateSkipAvatarAndReduceMargin();
      updateNonVipActions($scope.interaction.user.actions_allowed);

      const profileColumn = element.find('.profile-column')[0];
      const profileScrollbar = new PerfectScrollbar(profileColumn);
      const interactionsColumn = element.find('.interactions-column')[0];
      const interactionsScrollbar = new PerfectScrollbar(interactionsColumn);

      if ($scope.interaction?.user?.details?.is_conversation_closed) {
        $scope.interaction.messages.unshift({
          closed: true,
          avatarUrl: $scope.interaction.user.details.avatarUrl,
          avatarUrlIfError: 'ajs-assets/img/avatars/icon_client.png',
        });
      }

      $scope.$on('$destroy', () => {
        profileScrollbar.destroy();
        interactionsScrollbar.destroy();
      });

    }
  }
}

